import React from 'react'
import messages from '../../utils/messages'

const RedesSociales = (props) => {
  return (
    <section className="section redes-sociales">
      <div className="container">
        <p>{props.lang === "es" ? messages.es.siguenos : messages.en.siguenos}
          <a href="https://www.facebook.com/TantaPeru">
            <i className="fa fa-facebook"></i><span>/TantaPeru</span>
          </a>
        </p>
      </div>
    </section>
  )
}

export default RedesSociales;